import { GEMINI_AGENT_CARD, AgentConnectionsList, isGeminiConnection } from '../../settings-connections';
import { useTranslation } from '../../../../lib/i18n';
import { GeminiGlyph } from '../BrandGlyphs';
import { ConnectInstructionCard } from './ConnectInstructionCard';
import styles from './mobile.module.css';

/**
 * The Gemini Enterprise channel, mobile (Figma 13131-79284): one connect card whose Copy hands over
 * the A2A Agent Card JSON, over the already-connected Gemini agents (hidden when empty). Same shared
 * value and connections list as desktop; mobile card presentation.
 */
export function GeminiMobile() {
  const { t } = useTranslation();
  return (
    <div className={styles.channelBody}>
      <ConnectInstructionCard
        icon={<GeminiGlyph size={16.5} />}
        title={t('connections.connect.gemini.title')}
        description={t('connections.connect.gemini.instructions')}
        getValue={() => GEMINI_AGENT_CARD}
        copyBiName="copy-gemini-card"
      />
      <AgentConnectionsList filter={isGeminiConnection} />
    </div>
  );
}
